import {Point, PointExpression} from "leaflet";

export const APP_CONFIG_PARAMS = {
  SKELETON_TIMEOUT: 1200,
  MARKER_SIZE: new Point(46, 46),
  MARKER_ANCHOR: new Point(23, 46),
  MARKER_POPUP_ANCHOR: new Point(0, -46),
  WEATHER_CACHE: 2, //2 ore
  PHARMS_CACHE: 3 //3 ore
};
